import React, { ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
  animation?: 'fadeInUp' | 'slideInRight' | 'fadeIn' | 'none';
  duration?: number;
}

const PageTransition: React.FC<PageTransitionProps> = ({ 
  children, 
  className = '', 
  animation = 'fadeInUp',
  duration = 0.4 
}) => {
  const getAnimationClass = () => {
    switch (animation) {
      case 'fadeInUp':
        return 'page-transition-fade-in-up';
      case 'slideInRight':
        return 'page-transition-slide-in-right';
      case 'fadeIn':
        return 'page-transition-fade-in';
      case 'none':
        return '';
      default:
        return 'page-transition-fade-in-up';
    }
  };

  const animationStyle = {
    '--animation-duration': `${duration}s`
  } as React.CSSProperties;

  return (
    <div 
      className={`${getAnimationClass()} ${className}`}
      style={animationStyle}
    >
      {children}
    </div>
  );
};

export default PageTransition;
